import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { ThemeProvider } from './lib/theme-provider';
import { HelmetProvider } from 'react-helmet-async';
// Test avec un nouveau fichier analytics
import { initGA } from './lib/ga-service';

// Importer p5 et p5.sound pour toute l'application
import p5 from 'p5';

// Charger p5.sound après que p5 soit disponible
window.p5 = p5;
import('p5/lib/addons/p5.sound.min.js').catch(err => {
  console.error('Erreur lors du chargement de p5.sound:', err);
});

// Initialiser Google Analytics
initGA();

ReactDOM.createRoot(document.getElementById('root')).render(
  //<React.StrictMode>
    <HelmetProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </HelmetProvider>
  //</React.StrictMode>,
); 